import { getIntercomToken, IntercomToken } from "@/api/intercom";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { queryOptions } from "@tanstack/react-query";

export function getIntercomTokenOptions(
	userId: string,
	options: QueryOptionsWithoutKeyAndFn<IntercomToken>,
) {
	return queryOptions({
		queryKey: ["intercom-token", userId],
		queryFn: getIntercomToken,
		...options,
	});
}
